import { render, staticRenderFns } from "./ResetAcceptanceTab.vue?vue&type=template&id=7ec0dc10&"
import script from "./ResetAcceptanceTab.vue?vue&type=script&lang=js&"
export * from "./ResetAcceptanceTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports